<template>
    <section>
        <div class="card-header">
            {{ header }}
        </div>

        <template v-if="loadingState.ok">
            <div class="card-body overflow-auto" v-if="records.length">
                <!-- TODO: replace table with boo-grid after boo-grid refactoring -->
                <table v-if="records.length" class="table">
                    <thead>
                        <tr>
                            <th v-for="field in fields" scope="col">{{ field.name }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="record in records">
                            <td v-for="field in fields" style="max-width: 30px" :class="{'table-success': isSuccessCell(field.key)}">
                                {{ record[field.key] }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-text" v-else>
                No matches found.
            </div>
        </template>

        <template v-else-if="loadingState.error">
            <div class="card-text">
                {{ loadingState.message }}
            </div>
        </template>

        <template v-else>
            <div class="loader position-static"></div>
        </template>
    </section>
</template>

<script>
    export default {
        name: 'exclusions-list',
        props: {
            records: {
                type: Array,
                required: true,
            },
            fields: {
                type: Array,
                required: true,
            },
            header: {
                type: String,
                required: true,
            },
            loadingState: {
                type: Object,
                required: true,
            },
            successFieldKeys: {
                type: Array,
                default: [],
            },
        },
        methods: {
            isSuccessCell,
        },
    };

    function isSuccessCell(fieldKey) {
        return this.successFieldKeys.includes(fieldKey);
    }
</script>
